import styled from "styled-components";
import { responsiveWidth } from "responsive";

export const Wrapper = styled.nav`
  ${responsiveWidth}
  width: 100%;
  padding: 14px 0 12px;
  border-bottom: 1px solid #e8e8e8;
`;

export const List = styled.ol`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Item = styled.li<{ $current?: boolean }>`
  font-size: 13px;
  line-height: 1.4;
  letter-spacing: -0.03em;
  color: ${({ $current }) => ($current ? "#653cd5" : "#888888")};
  font-weight: ${({ $current }) => ($current ? 700 : 400)};

  @media (max-width: 767px) {
    font-size: 12px;
  }
`;

export const Separator = styled.li`
  font-size: 12px;
  line-height: 1;
  color: #cccccc;
  user-select: none;
  pointer-events: none;
`;
